var api = require("!../../../node_modules/.pnpm/style-loader@1.2.1_webpack@5.111.1/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../../node_modules/.pnpm/css-loader@5.2.7_webpack@5.111.1/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/.pnpm/postcss-loader@4.0.3_postcss@8.5.23_webpack@5.111.1/node_modules/postcss-loader/dist/cjs.js!../../../node_modules/.pnpm/sass-loader@10.2.0_sass@1.77.8_webpack@5.111.1/node_modules/sass-loader/dist/cjs.js!./releases.scss");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};